const collaborationManagementPage = {
  en: {
    collaborationManagementPage: {
      accessDenied: "Access denied",
      adminRequiredDesc: "Admin privileges required",
      lockRemoved: "Lock removed",
      forceUnlocked: "Force unlocked result {{id}}",
      unlockFailed: "Failed to unlock",
      cleanupComplete: "Cleanup complete",
      removedExpired: "Removed {{count}} expired locks",
      cleanupFailed: "Cleanup failed",
      expired: "Expired",
      allTypes: "All Types",
      electionTypes: {
        presidential: "Presidential",
        parliamentary: "Parliamentary",
        senatorial: "Senatorial",
        regional: "Regional",
        council: "Council"
      },
      accessDeniedTitle: "Access Denied",
      needAdmin: "You need administrator privileges to access this page.",
      backToDashboard: "Back to Dashboard",
      title: "Collaboration Locks",
      subtitle: "Manage active editing locks on results",
      cleanupExpired: "Cleanup Expired",
      refresh: "Refresh",
      activeLocks: "Active Locks",
      uniqueUsers: "Unique Users",
      lockTimeout: "Lock Timeout",
      fiveMin: "5 min",
      electionTypeLabel: "Election Type:",
      activeLocksDesc: "Results currently being edited by users",
      noActiveLocks: "No active locks",
      allAvailable: "All results are available for editing",
      resultId: "Result ID",
      electionType: "Election Type",
      lockedBy: "Locked By",
      lockedAt: "Locked At",
      expiresIn: "Expires In",
      actions: "Actions",
      forceUnlock: "Force Unlock",
      aboutTitle: "About Collaboration Locks",
      lockDurationLabel: "Lock Duration:",
      lockDurationText: " Locks automatically expire after 5 minutes of inactivity. Active editing sessions auto-extend the lock.",
      forceUnlockLabel: "Force Unlock:",
      forceUnlockText: " Use with caution. Force unlocking may cause data conflicts if the user is actively editing. The user will be notified that their lock was removed.",
      cleanupLabel: "Cleanup Expired:",
      cleanupText: " Removes all locks that have exceeded their timeout. This is safe and helps clean up stale locks.",
      forceUnlockTitle: "Force Unlock Result?",
      releasePre: "This will immediately release the lock held by ",
      releasePost: ". If they are actively editing, their changes may be lost.",
      cancel: "Cancel"
    }
  },
  fr: {
    collaborationManagementPage: {
      accessDenied: "Accès refusé",
      adminRequiredDesc: "Privilèges d'administrateur requis",
      lockRemoved: "Verrou supprimé",
      forceUnlocked: "Résultat {{id}} déverrouillé de force",
      unlockFailed: "Échec du déverrouillage",
      cleanupComplete: "Nettoyage terminé",
      removedExpired: "{{count}} verrou(s) expiré(s) supprimé(s)",
      cleanupFailed: "Échec du nettoyage",
      expired: "Expiré",
      allTypes: "Tous les types",
      electionTypes: {
        presidential: "Présidentielle",
        parliamentary: "Législative",
        senatorial: "Sénatoriale",
        regional: "Régionale",
        council: "Municipale"
      },
      accessDeniedTitle: "Accès refusé",
      needAdmin: "Vous devez disposer de privilèges d'administrateur pour accéder à cette page.",
      backToDashboard: "Retour au tableau de bord",
      title: "Verrous de collaboration",
      subtitle: "Gérez les verrous d'édition actifs sur les résultats",
      cleanupExpired: "Nettoyer les verrous expirés",
      refresh: "Actualiser",
      activeLocks: "Verrous actifs",
      uniqueUsers: "Utilisateurs uniques",
      lockTimeout: "Délai d'expiration du verrou",
      fiveMin: "5 min",
      electionTypeLabel: "Type d'élection :",
      activeLocksDesc: "Résultats actuellement en cours de modification par des utilisateurs",
      noActiveLocks: "Aucun verrou actif",
      allAvailable: "Tous les résultats sont disponibles pour modification",
      resultId: "ID du résultat",
      electionType: "Type d'élection",
      lockedBy: "Verrouillé par",
      lockedAt: "Verrouillé le",
      expiresIn: "Expire dans",
      actions: "Actions",
      forceUnlock: "Déverrouiller de force",
      aboutTitle: "À propos des verrous de collaboration",
      lockDurationLabel: "Durée du verrou :",
      lockDurationText: " Les verrous expirent automatiquement après 5 minutes d'inactivité. Les sessions d'édition actives prolongent automatiquement le verrou.",
      forceUnlockLabel: "Déverrouillage forcé :",
      forceUnlockText: " À utiliser avec précaution. Un déverrouillage forcé peut provoquer des conflits de données si l'utilisateur est en train de modifier. L'utilisateur sera informé que son verrou a été supprimé.",
      cleanupLabel: "Nettoyage des verrous expirés :",
      cleanupText: " Supprime tous les verrous ayant dépassé leur délai. Cette opération est sans risque et permet de nettoyer les verrous obsolètes.",
      forceUnlockTitle: "Déverrouiller le résultat de force ?",
      releasePre: "Cela libérera immédiatement le verrou détenu par ",
      releasePost: ". S'il est en train de modifier, ses modifications risquent d'être perdues.",
      cancel: "Annuler"
    }
  }
};

export default collaborationManagementPage;
